import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpenText, ChevronRight, Anchor } from "lucide-react";
import axios from "axios";
import { API } from "../../lib/api";
import { mediaUrl } from "../story/StoryShared";
import { SPECIALS } from "../../content/specials";

/* Homepage discovery row: latest published traveler stories + editorial specials. */
export const HomeStoriesRow = () => {
  const [stories, setStories] = useState([]);
  useEffect(() => { axios.get(`${API}/stories/feed/public?limit=4`).then((r) => setStories(r.data.items)).catch(() => {}); }, []);
  if (stories.length === 0 && SPECIALS.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 lg:px-8 mt-10 relative z-10" data-testid="home-stories-row">
      <div className="flex items-center justify-between gap-2 mb-3">
        <h2 className="font-heading font-900 text-xl sm:text-2xl flex items-center gap-2">
          <BookOpenText className="w-6 h-6 text-fuchsia-600" /> Traveler Stories &amp; Specials
        </h2>
        <Link to="/specials" data-testid="home-specials-link" className="text-sm text-primary hover:underline inline-flex items-center gap-1 shrink-0">
          All stories <ChevronRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-2.5 sm:gap-3">
        {SPECIALS.slice(0, 1).map((s) => (
          <Link key={s.slug} to={s.to} data-testid={`home-special-${s.slug}`}
            className={`group bg-gradient-to-br ${s.accent} text-white p-4 flex flex-col justify-between min-h-[160px]`}>
            <div className="text-[10px] font-mono uppercase tracking-widest opacity-75 flex items-center gap-1"><Anchor className="w-3 h-3" /> Special</div>
            <div>
              <div className="font-heading font-900 text-base leading-snug group-hover:underline">{s.title}</div>
              <div className="text-[11px] opacity-85 mt-0.5 line-clamp-2">{s.subtitle}</div>
            </div>
          </Link>
        ))}
        {stories.map((s) => (
          <a key={s.public_id} href={`/story/${s.public_id}`} data-testid={`home-story-${s.public_id}`}
            className="group border border-zinc-300 bg-white hover:border-fuchsia-500 transition-colors flex flex-col">
            {s.cover_media_id
              ? <img src={mediaUrl(s.id, s.cover_media_id)} alt="" className="w-full h-24 object-cover" loading="lazy" />
              : <div className="w-full h-24 bg-gradient-to-br from-fuchsia-100 to-indigo-100" />}
            <div className="p-2.5 flex-1 flex flex-col">
              <div className="font-heading font-900 text-sm leading-snug group-hover:underline line-clamp-2">{s.title}</div>
              <div className="mt-auto pt-1.5 text-[10px] text-muted-foreground truncate">By {s.author_display || "Anonymous Traveler"}{s.date_display ? ` · ${s.date_display}` : ""}</div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};
